import styled from 'styled-components'

export const OutlineContainer = styled.div`
display: flex;
flex-direction: column;
border: 1px solid var(--Azul);
border-radius: 20px;
padding: 1rem;
`
